export const THEME_CHROME_COLORS = {
  light: 'rgb(245, 246, 251)',
  dark: 'rgb(9, 17, 31)',
};

export const THEME_COLOR_MEDIA_QUERIES = [
  '(prefers-color-scheme: light)',
  '(prefers-color-scheme: dark)',
];

export const toSolidRgbColor = (color) => {
  const match = /^rgba?\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)(?:\s*,\s*[0-9.]+)?\s*\)$/i.exec(color || '');
  if (!match) return color;
  return `rgb(${match[1]}, ${match[2]}, ${match[3]})`;
};

const getThemeColorSelector = (media) => (
  media
    ? `meta[name="theme-color"][media="${media}"]`
    : 'meta[name="theme-color"]:not([media])'
);

const ensureThemeColorMeta = (media) => {
  const selector = getThemeColorSelector(media);
  let element = document.querySelector(selector);
  const created = !element;

  if (!element) {
    element = document.createElement('meta');
    element.name = 'theme-color';
    if (media) {
      element.setAttribute('media', media);
    }
    document.head.appendChild(element);
  }

  return {
    element,
    created,
    previousContent: element.getAttribute('content'),
  };
};

const restoreThemeColorMeta = ({ element, created, previousContent }) => {
  if (created) {
    element.remove();
    return;
  }

  if (previousContent === null) {
    element.removeAttribute('content');
  } else {
    element.setAttribute('content', previousContent);
  }
};

export const resolveBrowserChromeColor = (themeMode, activeTheme) => (
  THEME_CHROME_COLORS[themeMode] ||
  toSolidRgbColor(activeTheme?.background?.footer) ||
  toSolidRgbColor(activeTheme?.background?.default)
);

export const applyBrowserChromeTheme = ({ themeMode, activeTheme }) => {
  const root = document.documentElement;
  const chromeColor = resolveBrowserChromeColor(themeMode, activeTheme);
  const themeColorMetas = [
    ensureThemeColorMeta(),
    ...THEME_COLOR_MEDIA_QUERIES.map((media) => ensureThemeColorMeta(media)),
  ];

  const previousAppChromeColor = root.style.getPropertyValue('--app-chrome-color');
  const previousRootBackgroundColor = root.style.backgroundColor;
  const previousBodyBackgroundColor = document.body.style.backgroundColor;
  const previousColorScheme = root.style.colorScheme;

  themeColorMetas.forEach(({ element }) => {
    element.setAttribute('content', chromeColor);
  });
  root.style.setProperty('--app-chrome-color', chromeColor);
  root.style.backgroundColor = chromeColor;
  document.body.style.backgroundColor = chromeColor;
  root.style.colorScheme = themeMode;

  return () => {
    if (previousAppChromeColor) {
      root.style.setProperty('--app-chrome-color', previousAppChromeColor);
    } else {
      root.style.removeProperty('--app-chrome-color');
    }
    root.style.backgroundColor = previousRootBackgroundColor;
    document.body.style.backgroundColor = previousBodyBackgroundColor;
    root.style.colorScheme = previousColorScheme;
    themeColorMetas.forEach(restoreThemeColorMeta);
  };
};
